import React, {Component} from "react";
import {getData, postData} from "../../api/doLogin";
import {EventClient} from "../../util/eventClient";
import {hasPermission} from "../../api/permissionHelper";
import {RequiredPermissions} from "../../api/permissions";

export class TimeClock extends Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      active: false,
      first: true,
    };
    this.timer = null;
  }

  toggle() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    });
  }

  componentDidMount() {
    if (hasPermission(RequiredPermissions.TimeClockEmployee)) {
      this.updateFeed();
    }
  }

  componentWillUnmount() {
    if (this.timer) clearTimeout(this.timer);
  }

  updateFeed() {
    getData(`timeclock/mystatus`, {})
      .then((data) => {
        // console.log(data);
        if (data.status === "Success") {
          const existingFirst = this.state.first;
          this.setState({active: data.data.status || false, first: false}, () => {
            if (this.state.active && existingFirst) {
              EventClient.emit("TOAST_INFO", "You are Clocked In");
            }
          });
        }
      })
      .catch((err) => {
        console.log(err);
      }).finally(() => {
      this.timer = setTimeout(() => {
        this.updateFeed();
      }, 20000)
    });
  }

  delete(id) {
    postData(`sms/${id}`, {visible: 0})
      .then((data) => {
        // console.log(data);
        if (data.status === "Success") {
          this.setState({
            data: this.state.data.filter((sms) => sms.id !== id)
          });
        }
      })
      .catch((err) => {
        console.log(err);
      })
  }

  clockInOut() {
    postData(`timeclock/mystatus`, {})
      .then((data) => {
        // console.log(data);
        if (data.status === "Success") {
          this.setState({active: !this.state.active}, () => {
            EventClient.emit("TOAST_INFO", "You are now " + (this.state.active ? "Clocked In" : "Clocked Out"));
          });
        } else {
          EventClient.emit("TOAST_ERROR", "There was an error trying to " + (!this.state.active ? "Clock In" : "Clock Out"));
        }
      })
      .catch((err) => {
        console.log(err);
        EventClient.emit("TOAST_ERROR", "There was an error trying to " + (!this.state.active ? "Clock In" : "Clock Out"));
      })
  }

  render() {
    if (!hasPermission(RequiredPermissions.TimeClockEmployee)) return null;
    let bgColor = "#FFFFFF";
    let textColor = "black";
    let tipText = "Click to Clock In";
    if (this.state.active) {
      bgColor = "#6e0000";
      textColor = "white";
      tipText = "Click to Clock Out";
    }
    // className="d-md-down-none"
    return (
      <div title={tipText} style={{
        marginLeft: 5,
        padding: "3px 3px 0px 3px",
        backgroundColor: bgColor,
        borderRadius: 5,
        cursor: "pointer"
      }}
           onClick={() => {
             this.clockInOut()
           }}
      ><i className="cil-clock"
          style={{
            fontSize: 20,
            color: textColor
          }}></i></div>
    );
  }

}


// WEBPACK FOOTER //
// ./src/components/Header/TimeClock.js